import React from "react";
import { ChevronLeft, ChevronRight, ChevronUp, ChevronDown, Eye, EyeOff } from "lucide-react";

export const SEZ_DEF = ["todo", "info", "nf", "crit", "fatte", "amm_osp", "amm_op"];
export const layVuoto = () => ({ sezioni: [...SEZ_DEF], nascosti: [], ordine: {} });
const mergeSez = (saved) => {
  const arr = (saved || []).filter((s) => SEZ_DEF.includes(s));
  SEZ_DEF.forEach((s, i) => { if (!arr.includes(s)) { const prev = SEZ_DEF.slice(0, i).reverse().find((p) => arr.includes(p)); arr.splice(prev ? arr.indexOf(prev) + 1 : 0, 0, s); } });
  return arr;
};
export const normLay = (l) => ({ ...layVuoto(), ...(l || {}), sezioni: mergeSez(l?.sezioni) });

// ordina le tessere di una sezione secondo il layout; nasconde quelle tolte (in modifica restano visibili)
export const ordina = (sez, items, keyOf, lay, edit) => {
  const ord = lay?.ordine?.[sez] || [];
  const pos = (k) => { const i = ord.indexOf(k); return i < 0 ? 999 : i; };
  const sorted = [...items].sort((a, b) => pos(keyOf(a)) - pos(keyOf(b)));
  return edit ? sorted : sorted.filter((it) => !(lay?.nascosti || []).includes(`${sez}:${keyOf(it)}`));
};

const btn = "w-6 h-6 grid place-items-center rounded-md bg-white border border-slate-300 text-slate-600 hover:bg-amber-50 hover:text-amber-700 transition-colors";

export const TileEdit = ({ ed, sez, k, keys, children }) => {
  if (!ed) return children;
  const { lay, setLay } = ed;
  const id = `${sez}:${k}`;
  const nascosto = (lay.nascosti || []).includes(id);
  const sposta = (dir) => {
    const arr = [...keys]; const i = arr.indexOf(k); const j = i + dir;
    if (j < 0 || j >= arr.length) return;
    [arr[i], arr[j]] = [arr[j], arr[i]];
    setLay({ ...lay, ordine: { ...lay.ordine, [sez]: arr } });
  };
  const toggle = () => setLay({ ...lay, nascosti: nascosto ? lay.nascosti.filter((x) => x !== id) : [...(lay.nascosti || []), id] });
  return (
    <div className={`relative rounded-lg ring-2 ring-dashed ring-amber-300 ${nascosto ? "opacity-40" : ""}`} data-testid={`ds-edit-tile-${sez}-${k}`}>
      <div className="pointer-events-none">{children}</div>
      <div className="absolute -top-2.5 right-1 flex gap-0.5 z-10">
        <button type="button" onClick={() => sposta(-1)} className={btn} title="Sposta a sinistra" data-testid={`ds-edit-sx-${sez}-${k}`}><ChevronLeft size={13} /></button>
        <button type="button" onClick={() => sposta(1)} className={btn} title="Sposta a destra" data-testid={`ds-edit-dx-${sez}-${k}`}><ChevronRight size={13} /></button>
        <button type="button" onClick={toggle} className={btn} title={nascosto ? "Mostra" : "Nascondi"} data-testid={`ds-edit-vis-${sez}-${k}`}>{nascosto ? <EyeOff size={13} /> : <Eye size={13} />}</button>
      </div>
    </div>
  );
};

export const SezEdit = ({ ed, sez }) => {
  if (!ed) return null;
  const { lay, setLay } = ed;
  const sposta = (dir) => {
    const arr = [...lay.sezioni]; const i = arr.indexOf(sez); const j = i + dir;
    if (j < 0 || j >= arr.length) return;
    [arr[i], arr[j]] = [arr[j], arr[i]];
    setLay({ ...lay, sezioni: arr });
  };
  return (
    <span className="inline-flex gap-0.5 ml-2">
      <button type="button" onClick={() => sposta(-1)} className={btn} title="Sposta sezione su" data-testid={`ds-edit-su-${sez}`}><ChevronUp size={13} /></button>
      <button type="button" onClick={() => sposta(1)} className={btn} title="Sposta sezione giù" data-testid={`ds-edit-giu-${sez}`}><ChevronDown size={13} /></button>
    </span>
  );
};

const D = {
  "todo:infettive": "Ospiti con un evento sanitario aperto (febbre, infezioni, ecc.) da seguire oggi.",
  "todo:visite_saltate": "Visite mediche passate di cui non è ancora stato inserito l'esito.",
  "todo:ricette": "Ricette dei farmaci da caricare entro la scadenza.",
  "todo:checklist": "Controlli della check-list sanitaria ancora da fare (nel turno scelto: solo quelli di quell'orario).",
  "todo:visite_oggi": "Visite mediche in programma oggi.",
  "todo:par_misurare": "Ospiti a cui vanno misurati i parametri oggi.",
  "todo:docce": "Docce previste oggi e non ancora fatte.",
  "todo:alzate": "Ospiti non ancora alzati oggi.",
  "todo:messa": "Ospiti non ancora messi a letto oggi.",
  "todo:aiuti_alvo": "Ospiti che non vanno in bagno da 3 o più giorni: valutare un aiuto per l'alvo.",
  "todo:flebo": "Ospiti che non mangiano da 2 o più giorni: valutare flebo o supporti.",
  "todo:rientri": "Ospiti che rientrano in struttura oggi.",
  "todo:uscite": "Uscite programmate nei prossimi 7 giorni.",
  "todo:piano": "Attività del piano di lavoro del turno scelto qui sopra.",
  "todo:pulizie": "Pulizie della check-list previste oggi e non ancora fatte.",
  "todo:vedi_dashboard": "Operatori del turno scelto che non hanno ancora visto la dashboard.",
  "todo:presenza": "Operatori del turno scelto che non hanno ancora registrato la presenza.",
  "todo:vedi_consegne": "Operatori del turno scelto che non hanno ancora letto le consegne.",
  "info:chi": "Gli operatori in turno oggi, divisi per turno con gli orari del setup.",
  "info:visite_sett": "Le visite mediche dei prossimi 7 giorni.",
  "info:entrate_uscite": "Ospiti fuori struttura, rientri e uscite programmate.",
  "info:menu": "Il menù del giorno della struttura.",
  "info:news": "Comunicazioni e task per il personale.",
  "nf:docce": "Docce previste e non registrate.", "nf:checklist": "Controlli della check-list sanitaria non fatti.",
  "nf:checklist_motivo": "Controlli segnati come non fatti, con il motivo.", "nf:parametri": "Parametri da misurare non registrati.",
  "nf:non_alzati": "Ospiti non alzati nel turno.", "nf:non_messi_letto": "Ospiti non messi a letto nel turno.",
  "nf:alvo": "Alvo non registrato per gli ospiti.", "nf:pulizie": "Pulizie previste e non fatte.",
  "nf:consegne": "Turni in cui non sono state scritte le consegne.", "nf:dashboard": "Operatori in turno che non hanno visto la dashboard.",
  "nf:consegne_lette": "Operatori in turno che non hanno letto le consegne.", "nf:presenze": "Operatori in turno che non hanno spuntato la presenza.",
  "crit:pul_critiche": "Pulizie saltate nelle zone segnate come critiche.",
  "crit:eventi_corso": "Ospiti con un evento sanitario aperto (febbre, infezioni, ecc.) da seguire.",
  "amm_osp:certificati": "Ospiti presenti senza il certificato di autosufficienza caricato in Documenti.", "amm_osp:contratti": "Ospiti presenti senza il contratto con la struttura (o la convenzione firmata).",
  "amm_osp:ter_ord": "Ospiti presenti senza nessuna terapia ordinaria attiva.", "amm_osp:ter_bis": "Ospiti presenti senza nessuna terapia al bisogno attiva.",
  "amm_osp:ricette": "Ricette dei farmaci da caricare dopo le visite.", "amm_osp:visite_saltate": "Visite mediche passate di cui non è stato inserito l'esito.",
  "amm_op:buste": "Operatori interni con buste paga non caricate entro il 15 del mese successivo.", "amm_op:contratti": "Operatori interni senza il contratto di lavoro completo.",
  "amm_op:scadenza": "Operatori con il contratto scaduto o in scadenza nei prossimi 30 giorni.",
  "crit:eventi": "Nuovi eventi sanitari aperti nel giorno.", "crit:cadute": "Cadute e infortuni registrati.",
  "crit:param_critici": "Parametri fuori dai valori normali.", "crit:terapie_no": "Terapie non assunte dagli ospiti.",
  "crit:non_mangia": "Ospiti che non hanno mangiato.", "crit:non_beve": "Ospiti che non hanno bevuto.",
  "crit:flebo": "Flebo e supporti dati a chi non mangia o non beve.", "crit:alvo_critico": "Ospiti che non vanno in bagno da 3 o più giorni.",
  "crit:aiuti_alvo": "Aiuti per l'alvo dati nel giorno.", "crit:checklist_motivo": "Controlli della check-list non fatti con motivo.",
  "crit:docce_rifiutate": "Docce rifiutate dagli ospiti.",
  "fatte:consegne": "Consegne scritte nei turni del giorno.", "fatte:consegne_lette": "Operatori che hanno letto le consegne.",
  "fatte:presenze": "Operatori che hanno spuntato la presenza.",
};
export const desc = (sez, k, label, clic = true) => `${D[`${sez}:${k}`] || (sez === "fatte" ? `${label}: quante sono state registrate nel giorno.` : label)}${clic ? " Clicca per vedere il dettaglio." : ""}`;
export const visibili = (sez, arr, keyOf, lay) => arr.filter((x) => !(lay?.nascosti || []).includes(`${sez}:${keyOf(x)}`));
